import React from "react";
import "./birthday.css";

function Birthday({ clientes }) {

  // Funcion que devuelve la fecha de hoy formateada como 'AAAA-MM-DD'
  function getDate(separator = "-") {
    const newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${
      month < 10 ? `0${month}` : `${month}`
    }${separator}${date < 10 ? `0${date}` : `${date}`}`;
  }

  // Aca filtramos a los que tienen DD/MM iguales a la fecha de hoy
  const cumpleañeros = clientes.filter(
    (cli) => cli.cumpleaños.slice(5, 10) === getDate().slice(5, 10)
  );

  return (
    <>
      {cumpleañeros.length === 0 ? (
        <div className="birthdayContainer">
          <div className="body">
            <h5>No hay cumpleaños el dia de hoy</h5>
          </div>
        </div>
      ) : (
        <div className="birthdayContainer">
          <div className="body">
            <h4>Hoy Cumple Años:</h4>
            {cumpleañeros.map((cli) => {
              return (
                <h5 key={cli.id}>
                  {cli.nombre} {cli.apellido}
                </h5>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default Birthday;
